@if (isVisible()) {
  <!-- Same look as the company switcher (shares its stylesheet). -->
  <div class="company-switcher">
    <button
      type="button"
      class="company-switcher-trigger"
      (click)="toggleDropdown()"
      [attr.aria-expanded]="isOpen()"
      aria-haspopup="true"
      [attr.aria-label]="'Switch role. Current role: ' + activeLabel()"
    >
      <i class="hgi hgi-stroke hgi-rounded hgi-user company-icon"></i>
      <span class="company-name">{{ activeLabel() }}</span>
      <i class="fa-solid fa-chevron-down caret" [class.open]="isOpen()"></i>
    </button>

    @if (isOpen()) {
      <div class="company-switcher-panel access-panel">
        <ul class="company-list" aria-label="Available roles">
          @for (option of options(); track option.group_id) {
            <li>
              <button
                type="button"
                class="company-row access-row"
                [class.active]="isActive(option)"
                [attr.aria-current]="isActive(option) ? 'true' : null"
                (click)="selectGroup(option)"
              >
                <div class="company-logo access-avatar">
                  <span class="logo-fallback">{{ initialOf(option) }}</span>
                </div>
                <div class="company-info">
                  <span class="row-name">{{ option.label }}</span>
                </div>
                @if (isActive(option)) {
                  <i class="fa-solid fa-check row-check" aria-hidden="true"></i>
                }
              </button>
            </li>
          }
        </ul>
      </div>
    }
  </div>
}
